import React from 'react';

import {
	LIVE_PAGE_EDIT_EXPERIENCE,
	LIVE_PAGE_VIEW_EXPERIENCE,
	LIVE_PAGE_SESSION_EXPERIENCE,
	ExperienceStart,
} from '@confluence/experience-tracker';

const livePageSessionCollect = (events, experience) => {
	const liveEditExperienceFailed = events.find(
		({ action, name }) => action === 'taskFail' && name === LIVE_PAGE_EDIT_EXPERIENCE,
	);
	const liveEditExperienceAborted = events.find(
		({ action, name }) => action === 'taskAbort' && name === LIVE_PAGE_EDIT_EXPERIENCE,
	);
	const liveViewExperienceFailed = events.find(
		({ action, name }) => action === 'taskFail' && name === LIVE_PAGE_VIEW_EXPERIENCE,
	);
	const liveViewExperienceAborted = events.find(
		({ action, name }) => action === 'taskAbort' && name === LIVE_PAGE_VIEW_EXPERIENCE,
	);

	if (liveEditExperienceFailed || liveViewExperienceFailed) {
		experience.fail({
			error: new Error(`Live page ${liveViewExperienceFailed ? 'view' : 'edit'} experience failed`),
		});
	} else if (liveEditExperienceAborted || liveViewExperienceAborted) {
		experience.abort({
			reason: `Live page ${liveViewExperienceAborted ? 'view' : 'edit'} experience aborted`,
		});
	}
};

export function LivePageSessionExperienceStart() {
	return <ExperienceStart name={LIVE_PAGE_SESSION_EXPERIENCE} collect={livePageSessionCollect} />;
}
